import React from 'react';
import PropTypes from 'prop-types';
import PageWrapper from '../../shared/pagewrapper/PageWrapper.js';
import PageTitle from '../../shared/pagetitle/PageTitle.js';
import Message from '../../shared/message/Message.js';
import PageNaoEncontrada from '../../PageNaoEncontrada.jsx';
import useCheckModule from '../../../hooks/useCheckModule.js';

/*
 * Lugar das telas do administrativo PrimeFaces que ainda não foram migradas:
 * a rota e a permissão já existem, e a tela nova entra no lugar deste componente.
 */
export default function PageEmMigracao({titulo, modulo}) {
    const checkModule = useCheckModule();

    if (modulo && !checkModule(modulo)) {
        return <PageNaoEncontrada/>;
    }

    return (
        <PageWrapper>
            <PageTitle title={titulo}/>
            <Message type='info'>
                Esta tela ainda está sendo migrada para a nova versão. Enquanto isso, use o administrativo
                atual da Central de Bolsas.
            </Message>
        </PageWrapper>
    );
}

PageEmMigracao.propTypes = {
    titulo: PropTypes.string.isRequired,
    modulo: PropTypes.string
};
